const dashboardType = {
  purchaseOrder: 'purchaseOrder',
  changeOrder: 'change-order',
  quote: 'quote',
}
export default dashboardType
